import { render } from "./Register.vue?vue&type=template&id=7fa134c1&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=7fa134c1&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-7fa134c1"

export default script